import { useIntl } from "react-intl";
import { FormInput } from "~components/Form/FormInput";
import { FormHelpInfoModal } from "~components/FormHelpInfoModal/FormHelpInfoModal.tsx";
import type { UpsertPersonForm } from "~pages/Persons/PersonProfile/types/upsertPersonForm.ts";

const fields = [
  { titleIntlKey: "website", descriptionIntlKey: "form.help.person.website" },
  { titleIntlKey: "facebook", descriptionIntlKey: "form.help.person.facebook" },
  { titleIntlKey: "twitter", descriptionIntlKey: "form.help.person.twitter" },
  {
    titleIntlKey: "instagram",
    descriptionIntlKey: "form.help.person.instagram",
  },
  {
    titleIntlKey: "wikipedia",
    descriptionIntlKey: "form.help.person.wikipedia",
  },
];

export const SocialTab = ({ isLoading }: { isLoading: boolean }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="person-profile-columns">
      <FormHelpInfoModal titleKey={"person.social.information"} fields={fields} />
      <div className="form-additional-details-grid">
        <FormInput<UpsertPersonForm>
          showSkeleton={isLoading}
          label={formatMessage({ id: "website" })}
          name={["social", "website"]}
          inputProps={{ placeholder: formatMessage({ id: "website" }) }}
        />
        <FormInput<UpsertPersonForm>
          showSkeleton={isLoading}
          label={formatMessage({ id: "facebook" })}
          name={["social", "facebook"]}
          inputProps={{ placeholder: formatMessage({ id: "facebook" }) }}
        />
        <FormInput<UpsertPersonForm>
          showSkeleton={isLoading}
          label={formatMessage({ id: "twitter" })}
          name={["social", "twitter"]}
          inputProps={{ placeholder: formatMessage({ id: "twitter" }) }}
        />
        <FormInput<UpsertPersonForm>
          showSkeleton={isLoading}
          label={formatMessage({ id: "instagram" })}
          name={["social", "instagram"]}
          inputProps={{ placeholder: formatMessage({ id: "instagram" }) }}
        />
        <FormInput<UpsertPersonForm>
          showSkeleton={isLoading}
          label={formatMessage({ id: "wikipedia" })}
          name={["social", "wikipedia"]}
          inputProps={{ placeholder: formatMessage({ id: "wikipedia" }) }}
        />
      </div>
    </div>
  );
};
